import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { UserDetails } from 'src/app//shared/models/users/users/UserDetails';
import { ModelsEnum } from 'src/app//shared/models/users/users/enums/ModelsEnum';
import { SubmitReasonComponent } from 'src/app/shared/components/submit-reason/submit-reason.component';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { SwalService } from 'src/app/shared/services/swal.service';
import { UsersService } from 'src/app/shared/services/users.service';
import { EntityEnumSLA } from 'src/app//shared/models/sla/enums/EntityEnumSLA';
import { UserFormComponent } from 'src/app/features/users/components/user-management/user-form/user-form.component';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html'
})
export class UserDetailsComponent implements OnInit {
  actionsLoader = false;
  @Input() title!: string;
  @Input() userInfo!: any;
  @Input() isModuleAdmin!: boolean;
  @Input() pathologistLabType!: string;
  user!: UserDetails;
  dataLoading = false;
  @Input() module: any;
  @Input() entityId: any;
  @Output() closeDetails = new EventEmitter<boolean>();
  @Input() hideActionsFromUsersNotSuerAdmin: any;
  // image file
  avatar: any;
  avatarSrc!: string | undefined;
  maxFileSize = 0.8;
  fileTypeError = false;
  fileSizeError = false;
  userType: any;
  entityType!: string;
  @Input() moduleView!: string
  @Input() isTrainer!: boolean;

  constructor(
    public dialog: MatDialog,
    private translate: TranslateService,
    private service: UsersService,
    private auth: AuthenticationService,
    private swalService: SwalService
  ) { }

  ngOnInit(): void {
    if (this.module === ModelsEnum.Lab || this.module === ModelsEnum.LabUser) {
      this.userType = ModelsEnum.LabUser;
      this.entityType = EntityEnumSLA.lab;
    } else if (this.module === ModelsEnum.ScanningCenter || this.module === ModelsEnum.SCUser) {
      this.userType = ModelsEnum.SCUser;
      this.entityType = EntityEnumSLA.scanningCenter;
    } else if (this.module === ModelsEnum.Hospital || this.module === ModelsEnum.hospitalUser) {
      this.userType = ModelsEnum.hospitalUser;
      this.entityType = EntityEnumSLA.hospital;
    } else if (this.module === ModelsEnum.Clinic || this.module === ModelsEnum.clinicUser) {
      this.userType = ModelsEnum.clinicUser;
      this.entityType = EntityEnumSLA.clinic;
    } else if (this.module === ModelsEnum.VL || this.module === ModelsEnum.VLUser) {
      this.userType = ModelsEnum.VLUser;
      this.entityType = EntityEnumSLA.vl;
    } else if (this.module === ModelsEnum.pathologistUser) {
      this.entityType = this.pathologistLabType;
      this.userType = ModelsEnum.pathologistUser;
    } else if (this.module === ModelsEnum.pathologistRequest) {
      this.userType = ModelsEnum.pathologistRequest;
    }

    this.getDetails();
    // if (this.module === 'PATHOLOGIST_USER') {
    //   this.getPathologistDetails();
    // } else {
    // }
  }

  getDetails() {
    this.dataLoading = true;
    this.service.getDetails(this.module, this.userInfo, this.pathologistLabType, this.entityId).subscribe(
      (data: any) => {
        this.dataLoading = false;
        if (data) {
          this.user = data as UserDetails;
        }
      },
      (error: any) => {
        this.dataLoading = false;
      });
  }

  getPathologistDetails() {
    this.dataLoading = true;

    this.service.getDetails(this.module, this.userInfo).subscribe(
      (data: any) => {
        this.dataLoading = false;
        if (data) {
          this.user = data as UserDetails;
        }
      },
      (error: any) => {
        this.dataLoading = false;
      });
  }

  resendVerficationMail() {
    this.swalService.swalConfirmation(this.translate.instant('swalMsg.Yesdeleteit'))
      .then((result: any) => {
        if (result.value) {
          this.dataLoading = true;

        }
      });
  }

  openEditUser() {
    const dialogRef = this.dialog.open(UserFormComponent, {
      width: '620px',
      data: {
        record: this.user,
        userId: this.userInfo.labUserId,
        model: this.module, // LAB, Sc, VL
        isModuleAdmin: this.isModuleAdmin,
        pathologistLabType: this.pathologistLabType,
        labId: this.entityId,
        // this.user.userStatus !== 'NOT_VERIFIED'
        disableInpusForUpdate: (!this.hasPermission('SuperAdmin') && this.user.userType === 'PATHOLOGIST_USER' && this.user.memberSince) ? true : false,
        isTrainer: this.isTrainer
      }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.getDetails();
        this.service.refreshUsersList.next(true);
      }
    });
  }

  deleteRecord(isRemove = false) {
    this.swalService.swalConfirmation(this.translate.instant('swalMsg.Yesdeleteit'))
      .then((result: any) => {
        if (result.value) {
          this.actionsLoader = true;
          const query = { UserId: this.userInfo.labUserId, UserType: this.userType } as any;
          if (isRemove && this.user.lab?.length) {
            query.LabID = this.user.lab[0].labId;
            query.LabType = this.user.lab[0].labType;
          }
          this.service.checkBeforeDeleteUser(query).subscribe(
            (data: any) => {
              if (data.roles.length) {
                this.swalService.swalConfirmation(
                  this.translate.instant('swalMsg.Yesdeleteit'),
                  'This User has reviewer role',
                  'Are you sure to delete?'
                ).then((result: any) => {
                  if (result.value) {
                    this.deleteUser(query);
                  } else {
                    this.actionsLoader = false;
                  }
                });
              } else {
                this.deleteUser(query);
              }

            },
            (err: any) => {
              this.actionsLoader = false;
            }
          );

        }
      });
  }

  deleteUser(query: any) {
    this.service.deleteUser(query).subscribe(
      (data: any) => {
        this.actionsLoader = false;
        this.swalService.swalSuccess('')
          .then(() => {
            this.service.refreshUsersList.next(true);
            this.closeDetails.emit();
          });
      },
      (err: any) => {
        this.actionsLoader = false;
        const errors = JSON.parse(err.detail);
        let message = '';
        if (err.detail) {
          errors.ErrorDTO.forEach((error: any) => {
            if (error.ErrorCode === 'UserHaveCases') {
              message = 'User Can\'t Be Deleted because Have Cases';
            } else if (error.ErrorCode === 'UserHaveSlas') {
              message = 'Can\'t deactivate this pathologist because he have active SLA';
            }
          });
        } else {
          message = err.title;
        }
        this.swalService.swalFailed(message);
      });
  }

  checkRole(item: string) {
    if (this.user.roles) {
      return this.user.roles.includes(item);
    }
    return false;
  }

  resendActivationMail() {
    const query = {
      UserId: this.userInfo.labUserId,
      UserType: this.userType
    };
    this.swalService.swalConfirmation(this.translate.instant('swalMsg.yes'))
      .then((result: any) => {
        this.actionsLoader = true;
        if (result.value) {
          this.service.ResendActivationMail(query).subscribe(
            (data: any) => {
              this.actionsLoader = false;
              this.swalService.swalSuccess()
                .then(() => {
                  // this.getDetails();
                });
            }, (error: any) => {
              this.actionsLoader = false;
              // console.log('Try again!, ' + error);
              this.swalService.swalFailed(error.title);
            });
        } else {
          this.actionsLoader = false;
        }
      });
  }

  ResendResetPasswordMail() {
    const query = {
      UserId: this.userInfo.labUserId,
      UserType: this.userType
    };
    this.swalService.swalConfirmation(this.translate.instant('swalMsg.yes'))
      .then((result: any) => {
        this.actionsLoader = true;
        if (result.value) {
          this.service.ResendResetPasswordMail(query).subscribe(
            (data: any) => {
              this.actionsLoader = false;
              this.swalService.swalSuccess()
                .then(() => {
                  // this.getDetails();
                });
            }, (error: any) => {
              this.actionsLoader = false;
              // console.log('Try again!, ' + error);
              this.swalService.swalFailed(error.title);
            });
        } else {
          this.actionsLoader = false;
        }
      });
  }

  deactivateRecord() {
    const query = {
      UserId: this.userInfo.labUserId,
      UserType: this.userType
    };
    // if (this.module === ModelsEnum.Lab) {
    //   query.UserType = ModelsEnum.LabUser;
    // } else if (this.module === ModelsEnum.ScanningCenter) {
    //   query.UserType = ModelsEnum.SCUser;
    // } else if (this.module === ModelsEnum.Hospital) {
    //   query.UserType = ModelsEnum.hospitalUser;
    // } else if (this.module === ModelsEnum.Clinic) {
    //   query.UserType = ModelsEnum.clinicUser;
    // } else if (this.module === ModelsEnum.VL) {
    //   query.UserType = ModelsEnum.VLUser;
    // }
    this.swalService.swalConfirmation(this.translate.instant('swalMsg.yes'))
      .then((result: any) => {
        this.actionsLoader = true;
        if (result.value) {
          this.service.checkBeforeDeleteUser(query).subscribe(
            (data: any) => {
              if (data.roles.length) {
                this.swalService.swalConfirmation(
                  this.translate.instant('swalMsg.yes'),
                  'This User has reviewer role',
                  'Are you sure to Deactivate User?'
                ).then((result: any) => {
                  if (result.value) {
                    this.deactivateUser(query);
                  } else {
                    this.actionsLoader = false;
                  }
                });
              } else {
                this.deactivateUser(query);
              }

            },
            (err: any) => {
              this.actionsLoader = false;
            }
          );

        } else {
          this.actionsLoader = false;
        }
      });
  }

  deactivateUser(query: any) {
    this.service.DeactivateUser(query).subscribe(
      (data: any) => {
        this.actionsLoader = false;
        this.swalService.swalSuccess()
          .then(() => {
            this.getDetails();
            this.service.refreshUsersList.next(true);
          });
      }, (err: any) => {
        this.actionsLoader = false;
        const errors = JSON.parse(err.detail);
        let message = '';
        if (err.detail) {
          errors.ErrorDTO.forEach((error: any) => {
            if (error.ErrorCode === 'UserHaveCases') {
              message = 'User Can\'t Be Deactivate because Have Cases';
            } else if (error.ErrorCode === 'UserHaveSlas') {
              message = 'Can\'t deactivate this pathologist because he have active SLA';
            }
          });
        } else {
          message = err.title;
        }
        // console.log('Try again!, ' + error);
        this.swalService.swalFailed(message);
      });
  }

  activateUser() {
    const query = {
      UserId: this.userInfo.labUserId,
      UserType: this.userType
    };
    // if (this.module === ModelsEnum.Lab) {
    //   query.UserType = ModelsEnum.LabUser;
    // } else if (this.module === ModelsEnum.ScanningCenter) {
    //   query.UserType = ModelsEnum.SCUser;
    // } else if (this.module === ModelsEnum.Hospital) {
    //   query.UserType = ModelsEnum.hospitalUser;
    // } else if (this.module === ModelsEnum.Clinic) {
    //   query.UserType = ModelsEnum.clinicUser;
    // } else if (this.module === ModelsEnum.VL) {
    //   query.UserType = ModelsEnum.VLUser;
    // }
    this.swalService.swalConfirmation(this.translate.instant('swalMsg.yes'))
      .then((result: any) => {
        this.actionsLoader = true;
        if (result.value) {
          this.service.ActiveUser(query).subscribe(
            (data: any) => {
              this.actionsLoader = false;
              this.swalService.swalSuccess()
                .then(() => {
                  this.getDetails();
                  this.service.refreshUsersList.next(true);
                });
            }, (error: any) => {
              this.actionsLoader = false;
              // console.log('Try again!, ' + error);
              this.swalService.swalFailed(error.title);
            });
        } else {
          this.actionsLoader = false;
        }
      });
  }

  // File preview with validation
  uploadAvatar($event: any): void {
    const file: File = $event.target.files[0];
    if (file && this.validateFile(file)) {
      this.readThis(file);
      this.avatar = file;
    } else {
      this.avatarSrc = undefined;
      this.avatar = undefined;
    }
  }
  readThis(file: File): void {
    const myReader: FileReader = new FileReader();
    myReader.readAsDataURL(file);
    myReader.onloadend = (e) => {
      this.user.userImage = myReader.result as string;
      // this.avatarSrc = myReader.result as string;
    };
  }
  validateFile(file: File): any {
    if (this.fileType(file.name)) {
      this.fileTypeError = false;
      if ((file.size / (1024 * 1024)) <= this.maxFileSize) {
        this.fileSizeError = false;
      } else {
        this.fileSizeError = true;
        return false;
      }
    } else {
      this.fileTypeError = true;
      return false;
    }
    return true;
  }
  fileType(fileName: any): any {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'jpeg':
      case 'jpg':
        return 'jpg';
      case 'png':
        return 'png';
      default:
        return false;
    }
  }

  hasPermission(permission: string) {
    return this.auth.hasPermission(permission);
  }

  hasPermissionPlan(permission: string) {
    return this.auth.hasPermissionPlan(permission);
  }

  acceptRequest(id: any) {
    this.actionsLoader = true;
    const data = {
      pathologistId: id,
      action: 'ACCEPTED'
    };
    this.service.takeActionForPathologistRequest(data).subscribe(
      () => {
        this.actionsLoader = false;
        this.getDetails();
        this.service.refreshUsersList.next(true);
      }, (error: any) => {
        this.actionsLoader = false;
        // console.log('Try again!, ' + error);
      });
  }

  declineRequest(id: any) {
    const dataRecord = {
      title: this.translate.instant('trainer.declineRequest'),
      titleField: this.translate.instant('trainer.reasons'),
      comment: null,
      record: {
        id,
        pathologistId: id,
        action: 'REJECTED',
        commentProperty: 'rejectionReason'
      },
      serviceTarget: 'takeActionForPathologistRequest',
      service: this.service,
      showClose: true,
      btnSubmitTitle: this.translate.instant('trainer.submitReasons'),
      swalMessageSuccess: this.translate.instant('swalMsg.declinedsuccessfully')
    };
    const dialogRef = this.dialog.open(SubmitReasonComponent, {
      width: '500px',
      data: dataRecord
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.getDetails();
        this.service.refreshUsersList.next(true);
      }
    });
  }

}
